import React from "react";
import BaseListPage from "../../../../base/BaseListPage";
import { Button, InfiniteScroll, Progress } from "nq-component";
import CardView from "../../../../components/common/CardView";
import Table from "../../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import TrainingListForm from "../../Training/TrainingTable/training-list-form/TrainingListForm";
import Search from "../../../../components/Search";
import DateRangePicker from "../../../../components/common/DateRangePicker";
import { Select, Space } from "antd";
import TrainingReportPresenter from "./TrainingReportPresenter";

class KeyPosition extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new TrainingReportPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      progress: false,
      objects: [],
      object: {},
      targetcompetency: [],
      filteredCompetency: "",
      selectedCompetencies: [],
      count: 0,
      limit: 10,
      current: 1,
    };
  }
  async componentDidMount() {
    this.presenter.componentDidMount();
    const targetcompetency = await findObjectUseCase().execute(
      "management_training"
    );
    this.setState({ targetcompetency });
  }

  getCollectionName() {
    return "attendees";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  async onChangeOption(field, value) {
    if (field === "filteredCompetency") {
      const combinedValue = value.join("|");
      if (value.length > 0) {
        this.onChangeFilter("String", combinedValue, "targetcompetency");
      } else {
        this.onChangeFilter("String", combinedValue, "targetcompetency");
      }
    } else {
      this.setState({ [field]: value });
    }
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, targetcompetency, count, current, limit } =
      this.state;

    const includeLabel = Object.keys(schema.fields).filter(
      (fields) =>
        fields !== "Firstname" &&
        fields !== "Middlename" &&
        fields !== "surname" &&
        fields !== "training" &&
        fields !== "targetcompetency"
    );
    if (!schema) return <Progress />;
    const uniqueCompetency = [
      ...new Set(targetcompetency.map((item) => item.targetcompetency)),
    ];

    const GenerateExcel = () => {
      const { objects } = this.state;
      let csvContent = "Trainings,Date,Time\n"; // CSV header

      const escapeCsvValue = (value) => {
        if (typeof value === "string" && value.includes(",")) {
          return `"${value}"`;
        }
        return value;
      };

      objects.forEach((item) => {
        const training = escapeCsvValue(item.training || "");
        const date = escapeCsvValue(item.date || "");
        const time = escapeCsvValue(item.time || "");
        csvContent += `${training},${date},${time}\n`;
      });

      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Training Cost Report.csv`);
      document.body.appendChild(link);
      link.click();
      // Clean up
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    };
    return (
      <>
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div>
              <CardView style={{ borderRadius: 0 }}>
                <div className="row d-flex align-items-center ">
                  <div className="col-md-3 mt-1">
                    <Search
                      schemas={this.getSchemas()}
                      onSubmit={this.searchSubmit.bind(this)}
                      fields={schema.fields}
                    />
                  </div>
                  <div className="col-md-4 mt-1 bg-red position-relative ">
                    <Space
                      direction="vertical"
                      style={{
                        width: "100%",
                      }}
                    >
                      <Select
                        mode="multiple"
                        size={"large"}
                        allowClear
                        placeholder="Filter Multiple Targetcompetency"
                        onChange={(value) =>
                          this.onChangeOption("filteredCompetency", value)
                        }
                        options={[
                          ...uniqueCompetency.map((targetcompetency) => ({
                            label: targetcompetency,
                            value: targetcompetency,
                          })),
                        ]}
                        style={{
                          width: "100%",
                        }}
                      />
                    </Space>
                  </div>
                  <div className="col-md-5 mt-1">
                    <DateRangePicker
                      fields={["datefrom", "dateto", ""]}
                      onFilter={(filterObj) => {
                        this.searchSubmit(filterObj);
                      }}
                    />
                  </div>
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center">
                    <h4 className="text-primary">Employees List</h4>
                    <div style={{ marginLeft: "auto" }}>
                      <Button
                        className="btn bg-white border border-primary text-primary"
                        onClick={() => GenerateExcel()}
                      >
                        <i className="bi bi-filetype-csv" /> CSV
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At", ...includeLabel]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
        {this.state.isTrainingFormOpen && (
          <TrainingListForm
            closeTrainingForm={() =>
              this.setState({ isTrainingFormOpen: false })
            }
            refetchData={this.refetchData.bind(this)}
            object={this.state.object}
            action={this.state.action}
          />
        )}
      </>
    );
  }
}

export default KeyPosition;
